var React = require('react');

function White (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"10","stroke":"#F6F8FF","strokeWidth":"1","key":0}),React.createElement("circle",{"cx":"5.735","cy":"12.467","r":"1.951","fill":"#fff","key":1}),React.createElement("circle",{"cx":"9.28","cy":"7.508","r":"1.951","fill":"#fff","key":2}),React.createElement("circle",{"cx":"13.584","cy":"14.596","r":"1.951","fill":"#fff","key":3}),React.createElement("circle",{"cx":"17.128","cy":"9.533","r":"1.951","fill":"#fff","key":4}),React.createElement("path",{"fill":"#fff","d":"m8.821 7 .862.532-2.821 4.566L6 11.566z","key":5}),React.createElement("path",{"fill":"#fff","d":"m9.101 7.935.89-.485 3.2 5.877-.889.485zm7.954.913.815.602-3.397 4.6-.815-.6z","key":6})]);
}

White.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = White;

White.default = White;
